import { render, staticRenderFns } from "./rankTop.vue?vue&type=template&id=c850477a&"
import script from "./rankTop.vue?vue&type=script&lang=js&"
export * from "./rankTop.vue?vue&type=script&lang=js&"
import style0 from "./rankTop.vue?vue&type=style&index=0&id=c850477a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports